module.exports = __webpack_public_path__ + "img/alliance-bank-img.6c97d49c.png";